<template>
	<div class="upload-item" v-if="url" :class="{'type-file':type=='file'}">
		<a v-if="type=='image'" :href="url" target="_blank" >
			<div class="upload-item-img">
				<img :src="ossImg(url,'s')" />
			</div>
			<p>{{title}}</p>
		</a>
		<a :href="url" target="_blank" v-else>
			<Icon type="ios-paper-outline" size="50" />
			<br>
			<p>{{title}}</p>
		</a>
	</div>
</template>
<script>
export default {
	props:{
		url:{
			type:String,
			default:'image'
		},
		title:{
			type:String,
			default:''
		}
	},
	computed:{
		type(){
			var ImgRules = /.((jpg)|(png)|(JPG)|(PNG)|(jpeg)|(JPEG)|(gif))$/ig;
			return ImgRules.test(this.url)?'image':'file'
		}
	}
}
</script>
<style scoped lang="less">
.upload-item{
	width: 120px;
	height:120px;
	text-align: center;
	display: inline-block;
	margin-right: 15px;
	&.type-file{
		height: auto;
	}
	&-img{
		background: #efefef;
		padding:5px;
		width: 100%;
		height:100%;
		display: flex;
		align-items: center;
		border-radius: 5px;
		
	}
	img{
		max-width: 100%;
		max-height: 100%;
		margin: auto;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/common/FileShow.vue